import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class EquipmentModel extends BaseModel {

    constructor() {
        super({
                name: "equipment",
                tableName: 'equipment',
                label: "Danh sách thiết bị",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã thiết bị',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                name: { 
                    name: 'name',
                    type: "String",
                    label: 'Tên thiết bị',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                farm_name:{
                    name: 'farm_name',
                    type: "String",
                    label: 'Trang trại',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.farm_name = "";
                    }
                },
                unit: {
                    name: 'unit',
                    type: "String",
                    label: 'Mã Unit',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.Unit = "";
                    }
                },
                usage_productivity: {
                    name: 'usage_productivity',
                    type: "String",
                    label: 'Công suất',
                    class: "center",
                },
                reports: {
                    name: 'reports',
                    label: 'Báo cáo',
                    type: "CustomUrl",
                    class: "center",
                    custom: "String",
                    refs: 'reports {id name}',
                },
                status: {
                    name: 'status',
                    type: "Selection",
                    custom: 'SelectionText',
                    label: 'Tình trạng máy',
                    options: [
                        { value: 0, label: 'Không hoạt động' },
                        { value: 1, label: 'Hoạt động' }
                    ],
                    filter: {
                        type: 'select', 
                        optionLabel: 'label', 
                        optionKey: 'value', 
                        match: 'equals' 
                    }
                },
                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                    display: false,
                },
                farm_has_equipments: {
                    refs: 'farm_has_equipments {farm{id name}}',
                    display: false
                },
                equipment_has_units: {
                    refs: 'equipment_has_units {has_unit{id code name}}',
                    display: false
                },
                style: {
                    name: 'style',
                    display: false
                },
                size: {
                    name: 'size',
                    display: false
                },
                storage_cycle: {
                    name: 'storage_cycle',
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    display: false
                },
            },
            )
    }

}